import React from "react";
import VirtualList from "react-tiny-virtual-list";
import styles from "./react-tiny-virtual-list-wrapper.less";

type ReactTinyVirtualListWrapperProps = {
    children: any;
    maxHeight: number;
};

export const ReactTinyVirtualListWrapper = (props: ReactTinyVirtualListWrapperProps) => {
    const { children, maxHeight } = props;

    const DEFAULT_ITEM_HEIGHT = window.innerWidth < 992 ? 50 : 34;
    const initialOffset = 0;
    const childrenOptions = React.Children.toArray(children);
    const wrapperHeight = maxHeight < childrenOptions.length * DEFAULT_ITEM_HEIGHT ?
        maxHeight : childrenOptions.length * DEFAULT_ITEM_HEIGHT;

    const renderItem = (props: { style: any; index: number }) => {
        return (
            <li style={props.style} key={props.index}>
                {/*@ts-ignore */}
                {children[props.index]}
            </li>
        );
    }

    return Array.isArray(children) ? (
        <span className={styles.reactVirtualizedListWrapper}>
            {/**@ts-ignore **/}
            <VirtualList
                width="100%"
                height={wrapperHeight + 6}
                scrollOffset={initialOffset}
                itemCount={childrenOptions.length}
                itemSize={DEFAULT_ITEM_HEIGHT}
                renderItem={renderItem}
            />
        </span>
    ) : (
        <span className={styles.reactVirtualizedListWrapper}>
            <li className={styles.reactVirtualizedMenuPlaceholder}>{"No Options Available"}</li>
        </span>
    );
};